import React, { useEffect } from "react";
import { DashboardsEmbedWrapper } from "./dashboardEmbed";
import PropTypes from 'prop-types';
import { cookieAttributes } from "util/resumeCookieSettings";

function DashboardVisualizationReportPage(props) {
  const dashboardId = props?.match?.params?.dashboardId?.trim();

  useEffect(() => {
    if (dashboardId) {
      async function setResumeCookie() {
        const cookieValue = encodeURIComponent(`Dashboard Visualization - /dashboardVisualization/${dashboardId}`);
        const resumeCookie = Object.assign(cookieAttributes(), { name: 'platform_resume' }, { value: cookieValue });
        await cookieStore.set(resumeCookie);
      }
      setResumeCookie();
    }
  }, [dashboardId]);

  return (
    <div className="card">
      <div className="card-header text-light font-weight-bold container-fluid">
        <div className="row">
          <div className="col-12">Dashboard Visualization</div>
        </div>
      </div>
      <div>
        {dashboardId ? (
          <DashboardsEmbedWrapper dashboardId={dashboardId} />
        ) : (
          <div className="alert alert-warning">No dashboard specified</div>
        )}
      </div>
    </div>
  );
}

DashboardVisualizationReportPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      dashboardId: PropTypes.string
    })
  })
};

export default DashboardVisualizationReportPage;